/* Javascript for the modaal popups */
$('.gallery').modaal({
    type: 'image'
});

$('.close').click(function(){
    $('.modaal').modaal('close');
});
